import { useState, useEffect, useCallback } from 'react'
import { insufficientReportedRecently, isInsufficientMessage, spaNavigate } from '../utils/credits'

type ToastType = 'success' | 'info' | 'error'
/** Действие в тосте — ссылка (например, «Пополнить» → /tariffs); переход внутри приложения, без перезагрузки. */
export interface ToastAction { label: string; to: string }

interface ToastMessage {
  id: number
  text: string
  type: ToastType
  action?: ToastAction
}

let toastId = 0
let addToastGlobal: ((text: string, type: ToastType, action?: ToastAction) => void) | null = null
let lastText = ''
let lastAt = 0

export function showToast(text: string, type: ToastType = 'success', opts?: { action?: ToastAction }) {
  const now = Date.now()
  // Один и тот же текст подряд (место вызова повторило стандартный тост api/client) — не дублируем; свой тост о
  // нехватке токенов сразу после стандартного (у того есть «Пополнить») — тоже.
  if (text === lastText && now - lastAt < 3000) return
  if (!opts?.action && isInsufficientMessage(text) && insufficientReportedRecently(now)) return
  lastText = text
  lastAt = now
  if (addToastGlobal) addToastGlobal(text, type, opts?.action)
}

export default function ToastContainer() {
  const [toasts, setToasts] = useState<ToastMessage[]>([])

  const addToast = useCallback((text: string, type: ToastType = 'success', action?: ToastAction) => {
    const id = ++toastId
    setToasts(prev => [...prev, { id, text, type, action }])
    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id))
    }, action ? 7000 : 5000)
  }, [])

  useEffect(() => {
    addToastGlobal = addToast
    return () => { addToastGlobal = null }
  }, [addToast])

  if (toasts.length === 0) return null

  return (
    <div className="toast-container">
      {toasts.map(t => (
        <div key={t.id} className={`toast toast-${t.type}`}>
          {t.type === 'success' && (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <polyline points="8 12 11 15 16 9" />
            </svg>
          )}
          <span>{t.text}</span>
          {t.action && (
            <a className="toast__action" href={t.action.to} onClick={(e) => { e.preventDefault(); spaNavigate(t.action!.to) }}>{t.action.label}</a>
          )}
        </div>
      ))}
    </div>
  )
}
